import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box, Typography } from '@mui/material'
import React from 'react'

interface Props {
  sum: string
}

/**
 * Summary part of the custom tooltip which displays the weighted average price
 */
const TooltipSummary: React.VFC<Props> = ({ sum }) => {
  const { t } = useCustomTranslation()
  const label = t('dynamic-power-prices.cost-saving-chart.tooltip.weighted-average-price')

  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
      <Typography variant="button" component="h3" sx={{ fontWeight: 500 }}>
        {label}
      </Typography>
      <Typography variant="subtitle1">{sum}</Typography>
    </Box>
  )
}

export default TooltipSummary
